class Toolbar extends HTMLElement {
    constructor() {
        super();

        this.stickyBounds = document.getElementById('CollectionProductGrid').querySelector('.productListing');
        this.queryParams();
        this.closeModalClick();
        this.initCollectionToolbarPickers();

        if(this.querySelector('[data-view-as]')){
            this.mediaView = this.querySelector('[data-view-as]');
            this.mediaViewMobile = this.querySelector('[data-view-as-mobile]');

            this.mediaView.querySelectorAll('.icon-mode').forEach((modeButton) => {
                modeButton.addEventListener('click', this.onClickModeButtonHandler.bind(this));
            });

            this.mediaViewMobile.querySelectorAll('.icon-mode').forEach((modeMobileButton) => {
                modeMobileButton.addEventListener('click', this.onClickModeButtonMobileHandler.bind(this));
            });

            this.debouncedOnResizeMediaQuery = debounce(() => {
                this.setActiveViewModeMediaQuery(false);
            }, 200);

            var w = window.innerWidth;

            window.addEventListener('resize', () => {
                if (window.innerWidth == w) {
                    return 
                }

                w = window.innerWidth;

                this.debouncedOnResizeMediaQuery();
            });

            window.addEventListener('load', () => {
                this.debouncedOnResizeMediaQuery();
            });
        } else{
            if (window.innerWidth < 1100) {
                this.initViewModeLayout(2);
            }
        }

        if(this.querySelector('[data-limited-view]')){
            this.limitView = this.querySelector('[data-limited-view]');

            this.limitView.querySelectorAll('[data-limited-view-item]').forEach((limitButton) => {
                limitButton.addEventListener('click', this.onClickLimitButtonHandler.bind(this));
            });
        }

        if(this.querySelector('[data-toggle]')){
            this.querySelectorAll('[data-toggle]').forEach((dropdownButton) => {
                dropdownButton.addEventListener('click', this.onClickDropdownButtonHandler.bind(this));
            });

            window.addEventListener('load', () => {
                document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
            });
        }

        if(this.querySelector('[data-sorting]')){
            this.sortBys = this.querySelectorAll('[data-sorting]');
            const hasItem = this.sortBys[0].querySelector('[data-sort-by-item]') != null
            if(hasItem){
                this.sortBys.forEach(sortBy => {
                    sortBy.querySelectorAll('[data-sort-by-item]').forEach((sortByButton) => {
                        sortByButton.addEventListener('click', this.onClickSortByButtonHandler.bind(this));
                    });
                })
            }
        }

        if(this.checkNeedToConvertCurrency()){
            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
    }

    queryParams() {
        Shopify.queryParams = {};

        if (location.search.length > 0) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');

                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    }

    createURLHash(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');

        if (baseLink) {
            if (newQuery != "") {
                return baseLink + "?" + newQuery;
            } else {
                return baseLink;
            }
        } else {
            if (newQuery != "") {
                return location.pathname + "?" + newQuery;
            } else {
                return location.pathname;
            }
        }
    }

    updateURLHash(baseLink) {
        delete Shopify.queryParams.page;

        var newUrl = this.createURLHash(baseLink);

        history.pushState({
            param: Shopify.queryParams
        }, newUrl, newUrl);
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    onClickDropdownButtonHandler(event) {
        var buttonElement = event.currentTarget;

        if (buttonElement.dataset.mobile === 'mobile') {
            // const mobileSortDropdownMenu = this.querySelector('[data-sorting][data-mobile]')
            document.body.classList.add('toolbar-modal-open')
        }

        if (buttonElement.getAttribute('aria-expanded') === 'false'){
            buttonElement.setAttribute('aria-expanded', true);
        } else {
            buttonElement.setAttribute('aria-expanded', false);
        }
    }

    onClickSortByButtonHandler(event) {
        event.preventDefault();

        var buttonElement = event.currentTarget;
        this.sortBy = buttonElement.closest('[data-sorting]')

        if (!buttonElement.classList.contains('is-active')) {
            var value = buttonElement.querySelector('.text').getAttribute('data-value'),
                href = buttonElement.querySelector('.text').getAttribute('data-href'),
                text = buttonElement.querySelector('.text').innerText;

            if (this.sortBy.querySelector('.label-text') != null) {
                this.sortBy.querySelector('.label-text').innerText = text;
            }

            if (this.sortBy.querySelector('[data-toggle]') != null) {
                this.sortBy.querySelector('[data-toggle]')?.setAttribute('aria-expanded', false);
            }

            this.sortBy.querySelectorAll('[data-sort-by-item]').forEach((sortByButton) => {
                sortByButton.classList.remove('is-active');
            });

            buttonElement.classList.add('is-active');

            if (this.sortBy.dataset.mobile === 'mobile') {
                const dropdownButton = this.querySelector('[data-toggle][data-mobile="mobile"]')
                dropdownButton.setAttribute('aria-expanded', false); 
                document.body.classList.remove('toolbar-modal-open');
            }
            
            if(window.show_storefront_filter) {
                const form = document.querySelector('collection-filters-form');
                    form.querySelector('[name="sort_by"]').value = href;
                    form.onSubmitHandlerFromSortBy(event, form.querySelector('form'));
            } else {
                Shopify.queryParams.sort_by = href;
                this.updateURLHash();

                var newUrl = this.createURLHash();
                this.renderPage(newUrl);
            }
        }
    }

    getSections() {
        return [
            {
                id: 'main-collection-product-grid',
                section: document.getElementById('main-collection-product-grid').dataset.id,
            }
        ]
    }

    renderPage(href) {
        const sections = this.getSections();

        // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('is-loading');
        document.body.classList.add('has-halo-loader');

        sections.forEach((section) => {
            this.renderSectionFromFetch(href, section);
        });
    }

    renderSectionFromFetch(url, section) {
        fetch(url)
        .then(response => response.text())
        .then((responseText) => {
            const html = responseText;

            this.renderSidebar(html);
            this.renderProductGrid(html);
        });
    }

    renderSidebar(html) {
        if(document.getElementById('main-collection-filters')){
            const innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-filters').innerHTML;

            document.getElementById('main-collection-filters').innerHTML = innerHTML;
        }
    }

    renderProductGrid(html) {
        const innerHTML = new DOMParser()
                            .parseFromString(html, 'text/html')
                            .getElementById('CollectionProductGrid')
                            .querySelector('.collection').innerHTML;

        document.getElementById('CollectionProductGrid').querySelector('.collection').innerHTML = innerHTML;

        this.setActiveViewModeMediaQuery(true);

        if(window.compare.show){
            this.setLocalStorageProductForCompare({
                link: $('[data-compare-link]'),
                onComplete: null
            });
        }

        if(window.wishlist.show){
            this.setLocalStorageProductForWishlist();
        }

        if(window.innerWidth < 1025){
            // document.getElementById('CollectionProductGrid').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            window.scrollTo({
                top: document.getElementById('CollectionProductGrid').getBoundingClientRect().top + window.pageYOffset - 50,
                behavior: 'smooth'
            });
        }

        document.body.classList.remove('has-halo-loader');
    }

    setLocalStorageProductForCompare($link) {
        var count = JSON.parse(localStorage.getItem('compareItem')),
            items = $('[data-product-compare-handle]');

        if(count !== null){ 
            if(items.length > 0) {
                items.each((index, element) => {
                    var item = $(element),
                        handle = item.data('product-compare-handle');

                    if(count.indexOf(handle) >= 0) {
                        item.find('.compare-icon').addClass('is-checked');
                        item.find('.text').text(window.compare.added);
                        item.find('input').prop('checked', true);
                    } else {
                        item.find('.compare-icon').removeClass('is-checked');
                        item.find('.text').text(window.compare.add);
                        item.find('input').prop('checked', false);
                    }
                });
            }
        }
    }
  
    setLocalStorageProductForWishlist() {
        var wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

        if (wishlistList.length > 0) {
            wishlistList = JSON.parse(localStorage.getItem('wishlistItem'));
            
            wishlistList.forEach((handle) => {
                this.setProductForWishlist(handle);
            });
        }
        $('[data-wishlist-count]').text(wishlistList.length);
    }

    setProductForWishlist(handle){
        var wishlistList = JSON.parse(localStorage.getItem('wishlistItem')),
            item = $('[data-wishlist-handle="'+ handle +'"]'),
            index = wishlistList.indexOf(handle);
        
        if(index >= 0) {
            item
                .addClass('wishlist-added')
                .find('.text')
                .text(window.wishlist.added)
        } else {
            item
                .removeClass('wishlist-added')
                .find('.text')
                .text(window.wishlist.add);
        }
    }
  
    setActiveViewModeMediaQuery(ajaxLoading = true){
        var viewMode = this.mediaView?.querySelector('.icon-mode.active'),
            viewModeMobile = this.mediaViewMobile?.querySelector('.icon-mode.active'),
            column = parseInt(viewMode?.dataset.col),
            windowWidth = window.innerWidth;
        
        if(column != 1){
            if(document.querySelector('.sidebar--layout_vertical')){
                if (windowWidth < 768) {
                    if (column == 3 || column == 4 || column == 5) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth <= 1100 && windowWidth >= 768) {
                    if (column == 5 || column == 4 || column == 3) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth < 1300 && windowWidth > 1100) {
                    if (column == 5 || column == 4) {
                        column = 3;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-3').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-3').classList.add('active');
                    }
                } else if (windowWidth < 1700 && windowWidth >= 1300) {
                    if (column == 5) {
                        column = 4;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-4').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-4').classList.add('active');
                    }
                }
            } else{
                if (windowWidth < 768) {
                    if (column == 3 || column == 4 || column == 5) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth < 992 && windowWidth >= 768) {
                    if (column == 4 || column == 5) {
                        column = 3;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-3').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-3').classList.add('active');
                    }
                } else if (windowWidth < 1600 && windowWidth >= 992) {
                    if (column == 5) {
                        column = 4;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-4').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-4').classList.add('active');
                    }
                }
            }
            
            this.initViewModeLayout(column);
        } else{
            if(ajaxLoading){
                this.initViewModeLayout(column);
            }
        }
    }
    
    changeBannerPositions(column) {
        const collectionProductGrid = document.getElementById('main-collection-product-grid');
        const productLists = [...collectionProductGrid?.querySelectorAll('.product')];
        
        // Check if productLists has items and banner elements are found
        const banner1 = productLists.find(product => product?.dataset?.productBanner == 1);
        const banner2 = productLists.find(product => product?.dataset?.productBanner == 2);
        const banner3 = productLists.find(product => product?.dataset?.productBanner == 3);
        const bannerLists = [banner1, banner2, banner3].filter(banner => banner); // Filter out any null values

        // If no banners exist, stop the function execution
        if (bannerLists.length === 0) {
            console.warn('No banners found to reposition.');
            return;
        }

        const getCurrentPosition = (banner) => {
            const currentIndex = productLists.indexOf(banner);
            return {
                bannerNumber: banner?.dataset?.productBanner,
                currentIndex,
                originalIndex: parseInt(banner?.dataset?.firstPosition)
            };
        };

        const getNextPosition = (info) => {
            let nextPosition = info.currentIndex;
            switch (column) {
                case 2: {
                    if (info.bannerNumber == 1) {
                        nextPosition = 2;
                    } else if (info.bannerNumber == 2) {
                        nextPosition = 5;
                    } else if (info.bannerNumber == 3) {
                        nextPosition = 8;
                    }
                    collectionProductGrid?.classList.add('banner-full-width');
                    break;
                }
                case 3: {
                    if (info.bannerNumber == 3) {
                        nextPosition = info.originalIndex;
                    } else {
                        nextPosition = info.originalIndex - 1;
                    }
                    break;
                }
                case 4: {
                    nextPosition = info.originalIndex;
                    break;
                }
                case 5: {
                    if (info.bannerNumber == 3) {
                        nextPosition = info.originalIndex + 3;
                    } else {
                        nextPosition = info.originalIndex + 1;
                    }
                    break;
                }
                default: {
                    collectionProductGrid?.classList.remove('banner-full-width');
                }
            }
            return {
                bannerNumber: info.bannerNumber,
                originalIndex: info.originalIndex,
                currentIndex: nextPosition
            };
        };

        const clearBanner = () => {
            bannerLists.forEach(banner => {
                collectionProductGrid?.removeChild(banner);
            });
        };

        const setBannerPosition = (nextInfo) => {
            const clearedList = [...collectionProductGrid?.querySelectorAll('.product')];
            let productBefore = clearedList[nextInfo.currentIndex];

            const bannerToAppend = bannerLists.find(banner => banner?.dataset?.productBanner == nextInfo.bannerNumber);
            collectionProductGrid?.insertBefore(bannerToAppend, productBefore);
        };

        const bannersInfo = bannerLists.map(getCurrentPosition);
        const bannersNextInfo = bannersInfo.map(getNextPosition);
        clearBanner();
        bannersNextInfo.forEach(setBannerPosition);
    }


    initViewModeLayout(column) {
        const productListing = document.getElementById('CollectionProductGrid').querySelector('.productListing');

        if (!productListing) return;

        switch (column) {
            case 1:
                productListing.classList.remove('productGrid', 'column-5', 'column-4', 'column-3', 'column-2');
                productListing.classList.add('productList');

                
                // if(document.body.classList.contains('product-card-layout-01') || document.body.classList.contains('product-card-layout-05')){
                //     if(productListing.classList.contains('productList')){
                //         const cards = productListing.querySelectorAll('.card');
                //         cards.forEach(card => {
                //             const compareInput = card.querySelector('input.compare-checkbox');
                //             compareInput.disabled = true;
                //         })
                //     }
                // }

                break;

            default:
                switch (column) {
                    case 2:
                        productListing.classList.remove('productList', 'column-5', 'column-4', 'column-3');
                        productListing.classList.add('productGrid', 'column-2');

                        break;
                    case 3:
                        productListing.classList.remove('productList', 'column-5', 'column-4', 'column-2');
                        productListing.classList.add('productGrid', 'column-3');

                        break;
                    case 4:
                        productListing.classList.remove('productList', 'column-5', 'column-3', 'column-2');
                        productListing.classList.add('productGrid', 'column-4');

                        break;
                    case 5:
                        productListing.classList.remove('productList', 'column-4', 'column-3', 'column-2');
                        productListing.classList.add('productGrid', 'column-5');

                        break;
                }
        };
        
        if (document.querySelector('.collection-masonry')) {
            resizeAllGridItems();
        }

        if (document.querySelector('.collection-banner-adv')) {
            this.changeBannerPositions(column);
        }
    }

    onClickModeButtonHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget,
            viewMode = this.mediaView.querySelector('.icon-mode.active'),
            column = parseInt(buttonElement.dataset.col);

        if(!buttonElement.classList.contains('active')){
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaViewMobile.querySelectorAll('.icon-mode').forEach((element) => {
                var currentColum = parseInt(element.dataset.col);

                if(currentColum == column){
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickModeButtonMobileHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget,
            viewMode = this.mediaViewMobile.querySelector('.icon-mode.active'),
            column = parseInt(buttonElement.dataset.col);

        if(!buttonElement.classList.contains('active')){
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaView.querySelectorAll('.icon-mode').forEach((element) => {
                var currentColum = parseInt(element.dataset.col);

                if(currentColum == column){
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickLimitButtonHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget;

        if(!buttonElement.classList.contains('is-active')){
            var value = parseInt(buttonElement.querySelector('.text').dataset.value);

            this.limitView.querySelector('.label-text').innerText = value;
            this.limitView.querySelector('[data-toggle]').setAttribute('aria-expanded', false);

            this.limitView.querySelectorAll('[data-limited-view-item]').forEach((limitButton) => {
                limitButton.classList.remove('is-active');
            });

            buttonElement.classList.add('is-active');

            $.ajax({
                type: 'POST',
                url: '/cart.js',
                dataType: 'json',
                data: {
                    "attributes[pagination]": value
                },
                success: function (data) {
                    window.location.reload();
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
            });
        }
    }

    connectedCallback(){
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetScroll = $('#CollectionProductGrid .productListing').offset().top + 100;

        var windowWidth = window.innerWidth;

        if (windowWidth < 1025) {
            if (scrollTop > offsetScroll) {
                requestAnimationFrame(this.showSticky.bind(this));

                const headerMobile = document.querySelector('.header-mobile');
                if (headerMobile) {
                    const stickyType = headerMobile.dataset.stickyType;
                    const height = headerMobile.offsetHeight;
                    const isNavVisible = document.querySelector('.section-header-mobile')?.classList.contains('shopify-section-header-show');
                    const isMobileHidden = document.querySelector('.section-header-mobile')?.classList.contains('shopify-section-header-hidden');

                    this.style.top = (stickyType === "always" || (stickyType === "on_scroll" && isNavVisible)) ? `${height}px`
                                : (stickyType === "on_scroll" && isMobileHidden) ? "0"
                                : "0";
                }
            } else{
                requestAnimationFrame(this.hideSticky.bind(this));
            }
        }

        this.currentScrollTop = scrollTop;
    }

    hideSticky() {
        this.classList.remove('show-sticky', 'animate');
        this.closeDropdownPopupSticky();
    }

    showSticky() {
        this.classList.add('show-sticky', 'animate');
        this.closeDropdownPopupSticky();
    }

    closeModalClick() {
        this.closeMobileModal = this.querySelector('[data-sorting][data-mobile] .close-mobile-modal')
        if (!this.closeMobileModal) return;
        this.closeMobileModal.addEventListener('click', () => {
            const dropdownButton = this.querySelector('[data-toggle][data-mobile="mobile"]')
            if (!dropdownButton) return;
            dropdownButton.setAttribute('aria-expanded', false); 
            document.body.classList.remove('toolbar-modal-open')
        })
    }

    closeDropdownPopupSticky(){
        if(this.querySelector('.label-tab')){
            this.querySelectorAll('.label-tab').forEach((element) => {
                element.setAttribute('aria-expanded', false);
            });
        }
    }   

    initCollectionToolbarPickers() {
        if (Toolbar.collectionToolbarPickersBound) {
            Toolbar.syncCollectionPickers();
            return;
        }

        Toolbar.collectionToolbarPickersBound = true;

        document.addEventListener('click', (event) => {
            const modelTrigger = event.target.closest('[data-collection-model-drawer-open]');
            if (modelTrigger) {
                event.preventDefault();
                Toolbar.openCollectionModelDrawer(modelTrigger.getAttribute('data-drawer-id'));
                return;
            }

            const modelClose = event.target.closest('[data-collection-model-drawer-close]');
            if (modelClose) {
                event.preventDefault();
                Toolbar.closeCollectionModelDrawer(Toolbar.getCollectionModelDrawer(modelClose.getAttribute('data-drawer-id')), true);
                return;
            }

            const modelItem = event.target.closest('[data-collection-model-item]');
            if (modelItem) {
                event.preventDefault();
                Toolbar.applyCollectionModel(
                    modelItem.getAttribute('data-model-name'),
                    modelItem.getAttribute('data-model-url'),
                    modelItem.getAttribute('data-model-brand'),
                    modelItem.getAttribute('data-model-filter-value'),
                    modelItem.getAttribute('data-model-filter-param')
                );
                return;
            }

            const caseTypeTrigger = event.target.closest('[data-collection-case-type-open]');
            if (caseTypeTrigger) {
                event.preventDefault();
                Toolbar.openCollectionCaseTypeModal(caseTypeTrigger.getAttribute('data-modal-id'));
                return;
            }

            const caseTypeClose = event.target.closest('[data-collection-case-type-close]');
            if (caseTypeClose) {
                event.preventDefault();
                Toolbar.closeCollectionCaseTypeModal(Toolbar.getCollectionCaseTypeModal(caseTypeClose.getAttribute('data-modal-id')));
                return;
            }

            const caseTypeCard = event.target.closest('[data-collection-case-type-card]');
            if (caseTypeCard) {
                event.preventDefault();
                Toolbar.selectCollectionCaseTypeCard(caseTypeCard);
                return;
            }

            const caseTypeApply = event.target.closest('[data-collection-case-type-apply]');
            if (caseTypeApply) {
                event.preventDefault();
                Toolbar.applyCollectionCaseType(caseTypeApply.getAttribute('data-modal-id'));
            }
        });

        document.addEventListener('input', (event) => {
            const searchInput = event.target.closest('[data-collection-model-search]');
            if (!searchInput) return;
            Toolbar.filterCollectionModelDrawer(Toolbar.getCollectionModelDrawer(searchInput.getAttribute('data-drawer-id')), searchInput.value);
        });

        document.addEventListener('search', (event) => {
            const searchInput = event.target.closest('[data-collection-model-search]');
            if (!searchInput) return;
            Toolbar.filterCollectionModelDrawer(Toolbar.getCollectionModelDrawer(searchInput.getAttribute('data-drawer-id')), searchInput.value);
        });

        const syncCaseTypeViewport = () => Toolbar.syncCollectionCaseTypeViewportHeight();
        window.addEventListener('resize', syncCaseTypeViewport, { passive: true });
        window.addEventListener('orientationchange', syncCaseTypeViewport, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', syncCaseTypeViewport, { passive: true });
            window.visualViewport.addEventListener('scroll', syncCaseTypeViewport, { passive: true });
        }

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;

            const openedCaseTypeModal = document.querySelector('[data-collection-case-type-modal].is-open');
            if (openedCaseTypeModal) {
                Toolbar.closeCollectionCaseTypeModal(openedCaseTypeModal);
                return;
            }

            const openedModelDrawer = document.querySelector('[data-collection-model-drawer].is-open');
            if (openedModelDrawer) {
                Toolbar.closeCollectionModelDrawer(openedModelDrawer, true);
            }
        });

        window.HaloCollectionToolbar = window.HaloCollectionToolbar || {};
        window.HaloCollectionToolbar.sync = Toolbar.syncCollectionPickers;
        Toolbar.syncCollectionPickers();
    }

    static buildCollectionUrlWithParams(updater, baseUrl = window.location.href) {
        const url = new URL(baseUrl || window.location.href, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search || '');
        currentParams.forEach((value, name) => {
            if (Toolbar.shouldCarryCollectionQueryParam(name) && !url.searchParams.has(name)) {
                url.searchParams.append(name, value);
            }
        });
        updater(url.searchParams);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        const query = url.searchParams.toString();
        return `${url.pathname}${query ? `?${query}` : ''}`;
    }

    static shouldCarryCollectionQueryParam(name) {
        return name === 'model'
            || name === 'sort_by'
            || name === 'q'
            || name === 'type'
            || name === 'options[prefix]'
            || name.indexOf('filter.') === 0;
    }

    static getCollectionModelFilterParam() {
        return 'filter.p.m.custom.model_reference';
    }

    static isCollectionModelFilterParam(name) {
        return name === Toolbar.getCollectionModelFilterParam();
    }

    static getCollectionPathParts(path = window.location.pathname || '') {
        const parts = (path || '').split('/').filter(Boolean);
        const collectionsIndex = parts.indexOf('collections');
        if (collectionsIndex === -1) return null;

        return {
            localePrefix: collectionsIndex > 0 ? `/${parts.slice(0, collectionsIndex).join('/')}` : '',
            handle: (parts[collectionsIndex + 1] || '').trim().toLowerCase(),
            collectionPath: `/${parts.slice(collectionsIndex).join('/')}`.replace(/\/+$/, ''),
        };
    }

    static isCollectionPath(path = window.location.pathname || '') {
        return !!Toolbar.getCollectionPathParts(path);
    }

    static localizeCollectionPath(path) {
        const currentParts = Toolbar.getCollectionPathParts(window.location.pathname || '');
        const targetParts = Toolbar.getCollectionPathParts(path);
        if (!currentParts?.localePrefix || !targetParts || path.indexOf(currentParts.localePrefix + '/') === 0) return path;

        return `${currentParts.localePrefix}${targetParts.collectionPath}`;
    }

    static deleteCollectionModelFilterParams(params) {
        Array.from(params.keys()).forEach((name) => {
            if (Toolbar.isCollectionModelFilterParam(name)) {
                params.delete(name);
            }
        });
    }

    static isCollectionCaseTypeFilterParam(name) {
        if (!name || name.indexOf('filter.') !== 0) return false;
        const normalized = name.toLowerCase().replace(/\+/g, ' ');
        return normalized.indexOf('case type') > -1
            || normalized.indexOf('product type') > -1
            || normalized.indexOf('product type option') > -1
            || normalized.indexOf('product_type_reference') > -1;
    }

    static normalizeCollectionCaseTypeValue(value) {
        return (value || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
    }

    static dedupeCollectionCaseTypeCards(modal) {
        if (!modal) return;

        const cardsByLabel = new Map();
        modal.querySelectorAll('[data-collection-case-type-card]').forEach((card) => {
            const label = card.getAttribute('data-case-type-label')
                || card.querySelector('.collection-case-type-card__title')?.textContent
                || '';
            const key = Toolbar.normalizeCollectionCaseTypeValue(label);
            if (!key) return;

            const existingCard = cardsByLabel.get(key);
            if (!existingCard) {
                cardsByLabel.set(key, card);
                return;
            }

            const cardIsActive = card.classList.contains('is-active');
            const existingIsActive = existingCard.classList.contains('is-active');
            if (cardIsActive && !existingIsActive) {
                existingCard.remove();
                cardsByLabel.set(key, card);
                return;
            }

            card.remove();
        });
    }

    static getCollectionCaseTypeUrlValues(params = new URLSearchParams(window.location.search || '')) {
        const values = [];
        params.forEach((value, name) => {
            if (!Toolbar.isCollectionCaseTypeFilterParam(name)) return;
            const normalized = Toolbar.normalizeCollectionCaseTypeValue(value);
            if (normalized) values.push(normalized);
        });
        return values;
    }

    static deleteCollectionCaseTypeFilterParams(params) {
        Array.from(params.keys()).forEach((name) => {
            if (Toolbar.isCollectionCaseTypeFilterParam(name)) {
                params.delete(name);
            }
        });
    }

    static getCollectionModelDrawer(drawerId) {
        if (!drawerId) return null;
        return document.querySelector(`[data-collection-model-drawer][data-drawer-id="${drawerId}"]`);
    }

    static openCollectionModelDrawer(drawerId) {
        const drawer = Toolbar.getCollectionModelDrawer(drawerId);
        if (!drawer) return;

        if (drawer.getAttribute('data-drawer-mounted') !== 'true') {
            document.body.appendChild(drawer);
            drawer.setAttribute('data-drawer-mounted', 'true');
        }

        window.thehoodDeviceModelMap?.applyToModelItems?.(drawer);
        Toolbar.syncCollectionModelPicker();

        document.querySelectorAll('[data-collection-model-drawer].is-open').forEach((openedDrawer) => {
            if (openedDrawer !== drawer) Toolbar.closeCollectionModelDrawer(openedDrawer, true);
        });

        drawer.hidden = false;
        document.body.classList.add('model-drawer-open');

        window.requestAnimationFrame(() => {
            drawer.classList.add('is-open');
        });

        document.querySelectorAll(`[data-collection-model-drawer-open][data-drawer-id="${drawerId}"]`).forEach((trigger) => {
            trigger.setAttribute('aria-expanded', 'true');
        });

        Toolbar.filterCollectionModelDrawer(drawer, '');
        const searchInput = drawer.querySelector('[data-collection-model-search]');
        if (searchInput) {
            window.setTimeout(() => searchInput.focus(), 80);
        }
    }

    static closeCollectionModelDrawer(drawer, shouldResetSearch = false) {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        const drawerId = drawer.getAttribute('data-drawer-id');

        window.setTimeout(() => {
            if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 220);

        if (drawerId) {
            document.querySelectorAll(`[data-collection-model-drawer-open][data-drawer-id="${drawerId}"]`).forEach((trigger) => {
                trigger.setAttribute('aria-expanded', 'false');
            });
        }

        if (!document.querySelector('[data-collection-model-drawer].is-open')) {
            document.body.classList.remove('model-drawer-open');
        }

        if (shouldResetSearch) {
            const searchInput = drawer.querySelector('[data-collection-model-search]');
            if (searchInput) searchInput.value = '';
            Toolbar.filterCollectionModelDrawer(drawer, '');
        }
    }

    static syncCollectionModelFamilyVisibility(drawer, normalizedKeyword = '') {
        if (!drawer) return;

        const families = Array.from(drawer.querySelectorAll('[data-collection-model-family]'));
        let selectedFamily = null;
        const selectedItem = Array.from(drawer.querySelectorAll('[data-collection-model-item]'))
            .find((item) => item.classList.contains('is-selected'));

        families.forEach((family) => {
            const hasVisibleItem = family.querySelector('[data-collection-model-item]:not([hidden])');
            family.hidden = !hasVisibleItem;

            if (normalizedKeyword) {
                family.open = !!hasVisibleItem;
            } else if (hasVisibleItem && (family.querySelector('.linked-model-drawer__item.is-selected') || (selectedItem && family.contains(selectedItem)))) {
                selectedFamily = family;
            }
        });

        if (!normalizedKeyword) {
            if (selectedFamily) {
                families.forEach((family) => {
                    family.open = !family.hidden && family === selectedFamily;
                });
                return;
            }

            drawer.querySelectorAll('[data-collection-model-group]').forEach((group) => {
                const visibleFamilies = Array.from(group.querySelectorAll('[data-collection-model-family]:not([hidden])'));
                if (!visibleFamilies.length || visibleFamilies.some((family) => family.open)) return;
                visibleFamilies[0].open = true;
            });
        }
    }

    static filterCollectionModelDrawer(drawer, keyword = '') {
        if (!drawer) return;

        const normalized = keyword.toLowerCase().trim();
        const showAllModels = Toolbar.isCurrentModelCollectionPage();
        const availabilityReady = drawer.getAttribute('data-model-availability-ready') === 'true';
        const availableModelValues = new Set(
            Array.from(drawer.querySelectorAll('[data-collection-model-available-value]'))
                .map((element) => Toolbar.normalizeCollectionModelFilterValue(element.getAttribute('data-collection-model-available-value') || ''))
                .filter(Boolean)
        );
        const activeModelFilterValue = Toolbar.normalizeCollectionModelFilterValue(
            new URLSearchParams(window.location.search || '').get(Toolbar.getCollectionModelFilterParam()) || ''
        );
        const activeModelValue = (new URLSearchParams(window.location.search || '').get('model') || '').split(',')[0].trim().toLowerCase();
        const selectedItem = Array.from(drawer.querySelectorAll('[data-collection-model-item]')).find((item) => {
            const itemFilterValue = Toolbar.normalizeCollectionModelFilterValue(item.getAttribute('data-model-filter-value') || '');
            const itemModelValue = (item.getAttribute('data-model-name') || '').trim().toLowerCase();
            return (activeModelFilterValue && itemFilterValue === activeModelFilterValue) || (activeModelValue && itemModelValue === activeModelValue);
        });
        let visibleCount = 0;

        drawer.querySelectorAll('[data-collection-model-item]').forEach((item) => {
            const modelName = (item.getAttribute('data-model-name') || '').toLowerCase();
            const brandName = (item.getAttribute('data-model-brand') || '').toLowerCase();
            const familyName = (item.getAttribute('data-model-family') || '').toLowerCase();
            const modelFilterValue = Toolbar.normalizeCollectionModelFilterValue(item.getAttribute('data-model-filter-value') || '');
            const keywordMatched = normalized === ''
                || modelName.indexOf(normalized) > -1
                || familyName.indexOf(normalized) > -1
                || brandName.indexOf(normalized) > -1;
            const isAvailableInCurrentResults = availabilityReady
                && modelFilterValue
                && availableModelValues.has(modelFilterValue);
            const matched = item === selectedItem || (keywordMatched && (showAllModels || isAvailableInCurrentResults));
            item.hidden = !matched;
            if (matched) visibleCount += 1;
        });

        Toolbar.syncCollectionModelFamilyVisibility(drawer, normalized);

        drawer.querySelectorAll('[data-collection-model-group]').forEach((group) => {
            group.hidden = !group.querySelector('[data-collection-model-item]:not([hidden])');
        });

        const emptyState = drawer.querySelector('[data-collection-model-empty]');
        if (emptyState) emptyState.hidden = visibleCount !== 0;
    }

    static applyCollectionModel(modelName, modelUrl = '', modelBrand = '', modelFilterValue = '', modelFilterParam = '') {
        const resolvedModel = (modelName || '').trim();
        if (!resolvedModel) return;

        const mappedModel = window.thehoodDeviceModelMap?.resolveModel?.(resolvedModel);
        const resolvedModelUrl = (modelUrl || '').trim();
        if (Toolbar.isCurrentModelCollectionPage() && resolvedModelUrl && resolvedModelUrl !== '#') {
            window.location.href = Toolbar.buildModelCollectionUrl(resolvedModelUrl, modelBrand);
            return;
        }

        const resolvedFilterParam = (modelFilterParam || Toolbar.getCollectionModelFilterParam()).trim();
        const resolvedFilterValue = (mappedModel?.id || modelFilterValue || '').trim();
        if (!resolvedFilterValue && resolvedModelUrl && resolvedModelUrl !== '#') {
            window.location.href = Toolbar.buildModelCollectionUrl(resolvedModelUrl, modelBrand);
            return;
        }

        const path = window.location.pathname || '';
        const isFilterableListingPage = document.body.classList.contains('template-collection')
            || document.body.classList.contains('template-search')
            || Toolbar.isCollectionPath(path)
            || path === '/search'
            || path.indexOf('/search/') === 0;
        const baseUrl = isFilterableListingPage
            ? window.location.href
            : (resolvedModelUrl && resolvedModelUrl !== '#' ? resolvedModelUrl : window.location.href);

        window.location.href = Toolbar.buildCollectionUrlWithParams((params) => {
            params.delete('model');
            Toolbar.deleteCollectionModelFilterParams(params);
            params.set('model', resolvedModel);
            if (resolvedFilterParam && resolvedFilterValue) {
                params.set(resolvedFilterParam, resolvedFilterValue);
            }
        }, baseUrl);
    }

    static normalizeCollectionModelPath(url) {
        if (!url || url === '#') return '';

        try {
            const parsedUrl = new URL(url, window.location.origin);
            return parsedUrl.pathname.replace(/\/+$/, '');
        } catch (error) {
            return '';
        }
    }

    static normalizeCollectionModelBrand(value) {
        return (value || '').toString().trim().toLowerCase();
    }

    static getCurrentModelCollectionBrand() {
        const currentItem = Toolbar.getCurrentModelCollectionItem();

        return Toolbar.normalizeCollectionModelBrand(currentItem?.getAttribute('data-model-brand'));
    }

    static getCurrentModelCollectionItem() {
        const serverMatchedItem = document.querySelector('[data-collection-model-item][data-model-current-collection="true"]');
        if (serverMatchedItem) return serverMatchedItem;

        const currentPath = Toolbar.normalizeCollectionModelPath(window.location.href);
        if (!currentPath || !Toolbar.isCollectionPath(currentPath)) return null;

        const modelItems = Array.from(document.querySelectorAll('[data-collection-model-item]'));
        const exactPathItem = modelItems.find((item) => {
            const itemPath = Toolbar.normalizeCollectionModelPath(item.getAttribute('data-model-url'));
            const localizedItemPath = Toolbar.localizeCollectionPath(itemPath);
            return itemPath && (itemPath === currentPath || localizedItemPath === currentPath);
        });
        return exactPathItem || null;
    }

    static isCurrentModelCollectionPage() {
        return !!Toolbar.getCurrentModelCollectionItem();
    }

    static buildModelCollectionUrl(modelUrl, modelBrand = '') {
        const url = new URL(modelUrl, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search || '');
        const currentBrand = Toolbar.getCurrentModelCollectionBrand();
        const targetBrand = Toolbar.normalizeCollectionModelBrand(modelBrand);
        const shouldCarryCaseType = currentBrand && targetBrand && currentBrand === targetBrand;

        const sortBy = currentParams.get('sort_by');
        if (sortBy && !url.searchParams.has('sort_by')) {
            url.searchParams.set('sort_by', sortBy);
        }

        if (shouldCarryCaseType) {
            currentParams.forEach((value, name) => {
                if (!Toolbar.isCollectionCaseTypeFilterParam(name)) return;
                if (url.searchParams.has(name) && url.searchParams.getAll(name).includes(value)) return;
                url.searchParams.append(name, value);
            });
        }

        url.searchParams.delete('model');
        Toolbar.deleteCollectionModelFilterParams(url.searchParams);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');

        const localizedPath = Toolbar.localizeCollectionPath(url.pathname);
        return `${localizedPath}${url.search ? url.search : ''}`;
    }

    static getCollectionCaseTypeModal(modalId) {
        if (!modalId) return null;
        return document.querySelector(`[data-collection-case-type-modal][data-modal-id="${modalId}"]`);
    }

    static syncCollectionCaseTypeViewportHeight() {
        const height = Math.round(window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);
        if (height > 0) document.documentElement.style.setProperty('--collection-case-type-viewport-height', `${height}px`);
    }

    static openCollectionCaseTypeModal(modalId) {
        const modal = Toolbar.getCollectionCaseTypeModal(modalId);
        if (!modal) return;

        if (modal.getAttribute('data-modal-mounted') !== 'true') {
            document.body.appendChild(modal);
            modal.setAttribute('data-modal-mounted', 'true');
        }

        Toolbar.syncCollectionCaseTypePicker(modal);
        Toolbar.syncCollectionCaseTypeViewportHeight();

        modal.hidden = false;
        document.body.classList.add('collection-case-type-modal-open');

        window.requestAnimationFrame(() => {
            modal.classList.add('is-open');
        });

        document.querySelectorAll(`[data-collection-case-type-open][data-modal-id="${modalId}"]`).forEach((trigger) => {
            trigger.setAttribute('aria-expanded', 'true');
        });
    }

    static closeCollectionCaseTypeModal(modal) {
        if (!modal) return;
        Toolbar.syncCollectionCaseTypePicker(modal);
        modal.classList.remove('is-open');
        const modalId = modal.getAttribute('data-modal-id');

        window.setTimeout(() => {
            if (!modal.classList.contains('is-open')) modal.hidden = true;
        }, 180);

        if (modalId) {
            document.querySelectorAll(`[data-collection-case-type-open][data-modal-id="${modalId}"]`).forEach((trigger) => {
                trigger.setAttribute('aria-expanded', 'false');
            });
        }

        if (!document.querySelector('[data-collection-case-type-modal].is-open')) {
            document.body.classList.remove('collection-case-type-modal-open');
        }
    }

    static selectCollectionCaseTypeCard(card, options = {}) {
        if (!card || card.disabled) return;
        const modal = card.closest('[data-collection-case-type-modal]');
        if (!modal) return;
        const syncTrigger = options.syncTrigger === true;

        modal.querySelectorAll('[data-collection-case-type-card]').forEach((item) => {
            item.classList.toggle('is-active', item === card);
            item.setAttribute('aria-selected', item === card ? 'true' : 'false');
        });

        Toolbar.showCollectionCaseTypeDescription(modal, card.getAttribute('data-case-type-description-id'));
        if (syncTrigger) Toolbar.updateCollectionCaseTypeTrigger(card);
    }

    static showCollectionCaseTypeDescription(modal, descriptionId) {
        if (!modal) return;
        let visiblePanel = null;

        modal.querySelectorAll('[data-collection-case-type-description-panel]').forEach((panel) => {
            const isTarget = descriptionId && panel.id === descriptionId;
            panel.hidden = !isTarget;
            if (isTarget) visiblePanel = panel;
        });

        if (!visiblePanel) {
            const firstPanel = modal.querySelector('[data-collection-case-type-description-panel]');
            if (firstPanel) firstPanel.hidden = false;
        }
    }

    static updateCollectionCaseTypeTrigger(card) {
        if (!card) return;

        const label = card.getAttribute('data-case-type-label') || card.getAttribute('data-filter-value') || 'Select Case Type';
        const image = card.getAttribute('data-case-type-image') || '';

        document.querySelectorAll('[data-collection-case-type-selected-label]').forEach((element) => {
            element.textContent = label;
        });

        document.querySelectorAll('[data-collection-case-type-image-wrap]').forEach((wrap) => {
            const img = wrap.querySelector('[data-collection-case-type-selected-image]');
            if (!img || !image) {
                wrap.hidden = true;
                if (img) img.removeAttribute('src');
                return;
            }

            img.src = image;
            img.alt = label;
            wrap.hidden = false;
        });
    }

    static applyCollectionCaseType(modalId) {
        const modal = Toolbar.getCollectionCaseTypeModal(modalId);
        if (!modal) return;

        const activeCard = modal.querySelector('[data-collection-case-type-card].is-active');
        if (!activeCard) return;
        Toolbar.updateCollectionCaseTypeTrigger(activeCard);

        const filterUrl = (activeCard.getAttribute('data-filter-url') || '').trim();
        const paramName = activeCard.getAttribute('data-filter-param');
        const canonicalParamName = activeCard.getAttribute('data-canonical-filter-param');
        const filterValue = activeCard.getAttribute('data-filter-value');
        if (filterUrl) {
            const url = new URL(filterUrl, window.location.origin);
            const currentParams = new URLSearchParams(window.location.search || '');

            Toolbar.deleteCollectionCaseTypeFilterParams(url.searchParams);
            if (paramName && filterValue) {
                url.searchParams.set(paramName, filterValue);
                if (canonicalParamName && canonicalParamName !== paramName) {
                    url.searchParams.set(canonicalParamName, filterValue);
                }
            }

            currentParams.forEach((value, name) => {
                if (!Toolbar.shouldCarryCollectionQueryParam(name)) return;
                if (Toolbar.isCollectionCaseTypeFilterParam(name)) return;
                if (url.searchParams.has(name)) return;
                url.searchParams.append(name, value);
            });
            url.searchParams.delete('page');
            url.searchParams.delete('section_id');
            const query = url.searchParams.toString();
            window.location.href = `${url.pathname}${query ? `?${query}` : ''}`;
            return;
        }

        if (paramName && filterValue) {
            window.location.href = Toolbar.buildCollectionUrlWithParams((params) => {
                Toolbar.deleteCollectionCaseTypeFilterParams(params);
                params.delete(paramName);
                if (canonicalParamName) {
                    params.delete(canonicalParamName);
                }
                params.append(paramName, filterValue);
                if (canonicalParamName && canonicalParamName !== paramName) {
                    params.append(canonicalParamName, filterValue);
                }
            });
        }
    }

    static syncCollectionModelPicker() {
        window.thehoodDeviceModelMap?.applyToModelItems?.(document);

        const params = new URLSearchParams(window.location.search || '');
        let modelFilterValue = Toolbar.normalizeCollectionModelFilterValue(params.get(Toolbar.getCollectionModelFilterParam()) || '');
        let modelValue = (params.get('model') || '').trim();
        modelValue = modelValue ? modelValue.split(',')[0].trim() : '';

        if (!modelValue && modelFilterValue) {
            const matchedItem = Array.from(document.querySelectorAll('[data-collection-model-item][data-model-filter-value]')).find((item) => {
                return Toolbar.normalizeCollectionModelFilterValue(item.getAttribute('data-model-filter-value') || '') === modelFilterValue;
            });
            modelValue = (matchedItem?.getAttribute('data-model-name') || '').trim();
        }

        if (!modelValue && !modelFilterValue) {
            const currentModelItem = Toolbar.getCurrentModelCollectionItem();
            modelValue = (currentModelItem?.getAttribute('data-model-name') || '').trim();
            modelFilterValue = Toolbar.normalizeCollectionModelFilterValue(currentModelItem?.getAttribute('data-model-filter-value') || '');
        }

        document.querySelectorAll('[data-collection-model-selected-label]').forEach((element) => {
            const trigger = element.closest('[data-collection-model-drawer-open]');
            const fallback = trigger?.getAttribute('data-default-model-label') || 'Select Model';
            element.textContent = modelValue || fallback;
        });

        document.querySelectorAll('[data-collection-model-drawer]').forEach((drawer) => {
            const drawerItems = Array.from(drawer.querySelectorAll('[data-collection-model-item]'));
            let selectedItem = null;

            if (modelFilterValue) {
                selectedItem = drawerItems.find((item) => {
                    const itemFilterValue = Toolbar.normalizeCollectionModelFilterValue(item.getAttribute('data-model-filter-value') || '');
                    return itemFilterValue && itemFilterValue === modelFilterValue;
                }) || null;
            }

            if (!selectedItem && modelValue) {
                const normalizedModelValue = modelValue.toLowerCase();
                selectedItem = drawerItems.find((item) => {
                    return (item.getAttribute('data-model-name') || '').trim().toLowerCase() === normalizedModelValue;
                }) || null;
            }

            drawerItems.forEach((item) => {
                const isSelected = item === selectedItem;
                item.classList.toggle('is-selected', isSelected);
                const state = item.querySelector('.linked-model-drawer__item-state');
                if (state) state.hidden = !isSelected;
                const family = item.closest('[data-collection-model-family]');
                if (isSelected && family) family.open = true;
            });

            Toolbar.syncCollectionModelFamilyVisibility(drawer, '');
        });
    }

    static normalizeCollectionModelFilterValue(value) {
        let normalized = String(value || '').trim();
        if (!normalized) return '';
        try {
            normalized = decodeURIComponent(normalized);
        } catch (error) {
            // Keep the original value when Shopify returns a non-URI-safe token.
        }
        if (/^\d+$/.test(normalized)) return `gid://shopify/Metaobject/${normalized}`;
        return normalized;
    }

    static syncCollectionCaseTypePicker(root = document) {
        const modal = root.matches?.('[data-collection-case-type-modal]') ? root : root.querySelector?.('[data-collection-case-type-modal]');
        const allModals = modal ? [modal] : Array.from(document.querySelectorAll('[data-collection-case-type-modal]'));

        allModals.forEach((caseTypeModal) => {
            Toolbar.dedupeCollectionCaseTypeCards(caseTypeModal);
            const firstCard = caseTypeModal.querySelector('[data-collection-case-type-card]');
            if (!firstCard) return;

            const params = new URLSearchParams(window.location.search || '');
            const selectedValues = Toolbar.getCollectionCaseTypeUrlValues(params);
            const activeCard = selectedValues.length
                ? Array.from(caseTypeModal.querySelectorAll('[data-collection-case-type-card]')).find((card) => {
                    const cardValue = Toolbar.normalizeCollectionCaseTypeValue(card.getAttribute('data-filter-value'));
                    const cardLabel = Toolbar.normalizeCollectionCaseTypeValue(card.getAttribute('data-case-type-label'));
                    return selectedValues.includes(cardValue) || selectedValues.includes(cardLabel);
                })
                : null;

            if (!activeCard) {
                caseTypeModal.querySelectorAll('[data-collection-case-type-card]').forEach((card) => {
                    card.classList.remove('is-active');
                    card.setAttribute('aria-selected', 'false');
                });

                document.querySelectorAll('[data-collection-case-type-selected-label]').forEach((element) => {
                    const trigger = element.closest('[data-collection-case-type-open]');
                    element.textContent = trigger?.getAttribute('data-default-case-type-label') || 'Select Case Type';
                });

                document.querySelectorAll('[data-collection-case-type-image-wrap]').forEach((wrap) => {
                    const img = wrap.querySelector('[data-collection-case-type-selected-image]');
                    wrap.hidden = true;
                    if (img) img.removeAttribute('src');
                });

                Toolbar.showCollectionCaseTypeDescription(caseTypeModal, '');
                return;
            }

            Toolbar.selectCollectionCaseTypeCard(activeCard, { syncTrigger: true });
        });
    }

    static syncCollectionPickers() {
        Toolbar.syncCollectionModelPicker();
        Toolbar.syncCollectionCaseTypePicker();
    }

    onBodyClickEvent(event){
        if(this.querySelector('[data-toggle]')){
            this.querySelectorAll('[data-toggle]').forEach((dropdownButton) => {
                if (dropdownButton.dataset.mobile === 'mobile') {
                    const contentDropdown = this.querySelector('[data-sorting][data-mobile]')
                    if ((!contentDropdown.contains(event.target)) && (!dropdownButton.contains(event.target))){
                        dropdownButton.setAttribute('aria-expanded', false);
                        if (document.body.classList.contains('toolbar-modal-open')) {
                            document.body.classList.remove('toolbar-modal-open')
                        }
                    }
                } else {
                    var contentDropdown = dropdownButton.nextElementSibling;
                    if ((!contentDropdown.contains(event.target)) && (!dropdownButton.contains(event.target))){
                        dropdownButton.setAttribute('aria-expanded', false);
                    }
                }
            });
        }
    }
}

customElements.define('toolbar-item', Toolbar);
